module.exports = __webpack_public_path__ + "static/media/walking_man_pers.1dc81e5d.svg";